'use client';

import { isBrowser } from '@/helpers/is-browser';
import { IGtmParameters, useSendGtmEvent } from '@/hooks/use-send-gtm-event';
import { IMeetingplacePageHome } from '@/lib/fragments/meetingPlacePageHome';
import {
  IMeetingplacePageHomeMinified,
  IMeetingPlacePageHomeMinifiedExtendedTenantOpeningHours,
} from '@/lib/fragments/meetingPlacePageHome-minified';
import { IMeetingPlacePageLanding } from '@/lib/fragments/meetingPlacePageLanding';
import { useIsMPLivliFamily } from '@/providers/ConfigProvider';
import { useUser } from '@/providers/UserProvider';
import { useMemo } from 'react';

interface GtmPageViewProps {
  homepage?:
    | IMeetingplacePageHome
    | IMeetingplacePageHomeMinified
    | IMeetingPlacePageHomeMinifiedExtendedTenantOpeningHours
    | IMeetingPlacePageLanding
    | null;
  language: string;
  pageTitle: string;
  excludeBrowserTitleSuffix?: boolean;
  isSustainabilityPage?: boolean;
}

export function GtmPageView({
  homepage,
  language,
  pageTitle,
  excludeBrowserTitleSuffix,
  isSustainabilityPage,
}: GtmPageViewProps) {
  const { user } = useUser();
  const isLivliFamily = useIsMPLivliFamily();

  let businessUnitCode = '';

  if (homepage && 'meetingPlace' in homepage) {
    const meetingPlace = homepage?.meetingPlace;
    businessUnitCode = meetingPlace.businessUnitCode;
  }
  const browserTitle = `${pageTitle} ${
    excludeBrowserTitleSuffix ? '' : homepage?.htmlTitleSuffix
  }`;

  let tagId = '';
  if (homepage && 'reservedTagId' in homepage) {
    tagId = homepage?.reservedTagId?.replace('meetingPlace', '') ?? '';
  }
  const gtmParams = useMemo(() => {
    return {
      event: 'virtual_page_view',
      meeting_place: tagId ?? '',
      meeting_place_id: businessUnitCode ?? '',
      page_title: browserTitle,
      market: language,
      page_path: isBrowser ? window.location.pathname : '',
      user_status: isLivliFamily ? (user ? 'logged_in' : 'guest') : undefined,
      is_sustainability_page: isSustainabilityPage ? true : false,
    } as IGtmParameters;
  }, [tagId, businessUnitCode, language, browserTitle]);

  useSendGtmEvent(gtmParams);

  return null; // 👈 intentional
}
